module.exports = __webpack_public_path__ + "media/components/Builder/Library/Images/Tools/AlignCenter-1fd6ebe713bf70ccd651a1b9ee2fe641.svg";